import { Link } from "react-router-dom";
import { Crown } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useCurrency } from "@/context/CurrencyContext";

// Red promo banner: 24h-free-on-signup pitch + sign-up CTA.
export const SubscribeBanner = ({ className = "" }) => {
  const { t } = useTranslation();
  const { fromDisplay } = useCurrency();
  return (
    <div data-testid="subscribe-banner"
      className={`bg-gradient-to-r from-brand via-red-600 to-brand text-white shadow-lg ${className}`}>
      <div className="px-4 sm:px-8 lg:px-12 py-2.5 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-center">
        <p className="text-sm sm:text-base font-semibold leading-snug">
          {t("banner.trial", { price: fromDisplay || "R19.99" })}
        </p>
        <Link to="/register" data-testid="subscribe-banner-btn"
          className="shrink-0 inline-flex items-center gap-1.5 bg-white text-brand font-bold text-sm px-4 py-1.5 rounded-full hover:bg-zinc-100 transition-colors">
          <Crown size={14} /> {t("banner.cta")}
        </Link>
      </div>
    </div>
  );
};
